import url from './url';



export default url(({ collectionId = ':collectionId' }) => `/collections/${collectionId}/view`);
